import { UnitOfMeasureEnum } from "../../../shared/components/formulario/select/SelectUnitOfMeasure";

export interface LaborBudgetContract {
  id?: string;
  isClt: boolean;
  description: string;
  unitOfMeasure: UnitOfMeasureEnum;
  wage?: number;
  baseWage?: number;
}

export enum CostTypeEnum {
  DIRECT = 'direct',     // Custos diretamente ligados à execução da obra
  INDIRECT = 'indirect'  // Custos de apoio, administração e despesas gerais
}

